import React from 'react'
import Button from '@mui/material/Button'
import { useCMSContext } from '../CMS/CMSContext'
import { extensionToLowerCase, removeSpecialCharactersFromStringInVideo } from '../../../resources/Utils'

const ChooseVideo = ({
  videos,
  setVideos,
  fireDepartmentIdentifier,
  max,
  elementsAdded,
  isGalleryForm,
  setErrorLabel,
  isMessageEnabled = true,
  marketingDialog = false,
  marketingSetter = null,
  localMarketingSetter = null,
  isMarketing = false,
  disableHandleClick = false
}) => {
  const { state } = useCMSContext()
  const { departmentTimeBalance } = state

  let timeLeft = departmentTimeBalance.secondsLeft
  const hiddenFileInput = React.useRef(null)

  const handleClick = (event) => {
    if (!disableHandleClick) {
      hiddenFileInput.current.click()
    }
    
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  const handleChange = async (event) => {

    const fileUploaded = event.target.files[0]
    if (fileUploaded) {
      const lowerCasedFileName = extensionToLowerCase(fileUploaded.name)
      const fileName = removeSpecialCharactersFromStringInVideo(lowerCasedFileName)
      const file = {}
      file.object = fileUploaded
      let add = true
      if (max > 1 && elementsAdded === max) {
        if (marketingDialog) {
          localMarketingSetter((prevState) => ({
            ...prevState,
            errorLabel: 'Max number of files'
          }))
        } else {
          setErrorLabel('Max number of files')
        }

        add = false
      }

      if (fileUploaded.size > 200000000) {
        file.error = 'File limit size exceeds'
        add = false
      }

      const size = formatBytes(fileUploaded.size)
      file.fileSize = size
      const allowedExtensions = /(\.mp4|\.mov|\.webm)$/i
      if (!allowedExtensions.exec(fileName)) {
        file.error = 'File extension not allowed'
        add = false
      }

      if (add) {
        //get url from uploaded video
        var objectUrl = URL.createObjectURL(fileUploaded)
        const videoRef = document.createElement('video')
        //set src to the local path
        videoRef.src = objectUrl
        //until the metadata is ready, save the file in stage
        videoRef.onloadedmetadata = (e) => {
          const duration = parseInt(e.target.duration)

          //validation time duration
          if ((timeLeft && duration > timeLeft) || timeLeft <= 0) {
            //release memory
            URL.revokeObjectURL(objectUrl)

            let minLeft = parseInt(timeLeft / 60)
            let secLeft = parseInt(timeLeft % 60)
            if (marketingDialog) {
              localMarketingSetter((prevState) => ({
                ...prevState,
                errorLabel: `You have only ${minLeft} minutes and ${secLeft} seconds left for uploading videos. `
              }))
              setTimeout(() => {
                localMarketingSetter((prevState) => ({
                  ...prevState,
                  errorLabel: ''
                }))
              }, 5000)
            } else {
              setErrorLabel(
                `You have only ${minLeft} minutes and ${secLeft} seconds left for uploading videos. `
              )
              setTimeout(() => {
                setErrorLabel('')
              }, 5000)
            }

            return
          }

          file.secondsDuration = duration
          file.FileName = fileName
          if (!isGalleryForm) file.FireDepartmentIdentifier = fireDepartmentIdentifier
          file.binary = fileUploaded
          file.fileName = `${fileName.split('.')[0]}_${Date.now().toString()}.${
            fileName.split('.')[1]
          }`
          file.isNew = true
          file.caption = ''
          file.originalName = fileName
          file.type = 'video'
          if (max > 1) {
            if (marketingDialog) {
              marketingSetter((prevState) => ({
                ...prevState,
                videos: [...prevState.videos, file]
              }))
            } else {
              setVideos([...videos, file])
            }
          } else {
            if (marketingDialog) {
              marketingSetter((prevState) => ({
                ...prevState,
                videos: [...prevState.videos, file]
              }))
            } else {
              setVideos([file])
            }
          }

          //release memory url
          URL.revokeObjectURL(objectUrl)
        }
        hiddenFileInput.current.value = null
      } else {
        if (max > 1 && elementsAdded === max) {
          if (marketingDialog) {
            localMarketingSetter((prevState) => ({
              ...prevState,
              errorLabel: 'Max number of files'
            }))
          } else {
            setErrorLabel('Max number of files')
          }
        } else {
          if (marketingDialog) {
            localMarketingSetter((prevState) => ({
              ...prevState,
              errorLabel: file.error
            }))
          } else {
            setErrorLabel(file.error)
          }
        }
        setTimeout(() => {
          if (marketingDialog) {
            localMarketingSetter((prevState) => ({
              ...prevState,
              errorLabel: ''
            }))
          } else {
            setErrorLabel('')
          }
        }, 5000)
      }
    }
  }
  return (
    <>
      <div style={{ height: '100px' }}>
        <Button
          onClick={handleClick}
          style={{ maxWidth: '250px', minWidth: '250px' }}
          variant="outlined"
          color="primary"
          className="button form-control"
          size="medium"
        >
          Choose Video
        </Button>
        {isMessageEnabled && !marketingDialog ? (
          <p
            style={{
              padding: '3px 0px',
              fontStyle: 'italic',
              fontSize: '14px',
              fontFamily: 'lato',
              fontWeight: 'normal',
              textAlign: 'left',
              color: '#535353',
              opacity: '1'
            }}
          >
            You can add up to {max} files (images, videos) and unlimited online videos
          </p>
        ) : (
          <p></p>
        )}
        {
          !isMarketing &&
          !marketingDialog && (
          <p
            style={{
              padding: '3px 0px',
              fontStyle: 'italic',
              fontSize: '14px',
              fontFamily: 'lato',
              fontWeight: 'normal',
              textAlign: 'left',
              color: '#4caf50',
              opacity: '1'
            }}
          >
            You have <strong>{parseInt(timeLeft / 60)}</strong> minutes{' '}
            {timeLeft % 60 > 0 ? ` and ${timeLeft % 60} seconds ` : ''} of video space left
          </p>
        )}
      </div>
      <input
        type="file"
        accept="video/mp4,video/webm,video/mov"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </>
  )
}

export default ChooseVideo
